module.exports = __webpack_public_path__ + "img/modal-warning.c9d2be65.svg";